import { Injectable } from "@angular/core";
import { Account } from "app/shared/models/account";
import { AccountService } from "app/core/services/account.service";
import { BehaviorSubject, combineLatest, Observable } from "rxjs";
import { distinctUntilChanged, filter, map } from "rxjs/operators";
import { Router } from "@angular/router";
import { environment } from "environments/environment";
import { UserModule } from "app/shared/models/modules-names";

@Injectable({
  providedIn: "root",
})
export class NconnectAccountSelectionService {
  private nconnectApiUrl: string;

  private isNconnectVoiceAccountSelectedSource: BehaviorSubject<
    boolean | null
  > = new BehaviorSubject<boolean | null>(null);
  private selectedNconnectVoiceAccountSource: BehaviorSubject<Account | null> =
    new BehaviorSubject<Account | null>(null);

  public isNconnectAccountSelected$: Observable<boolean | null> =
    this.isNconnectVoiceAccountSelectedSource.asObservable();
  public selectedNconnectVoiceAccount$: Observable<Account | null> =
    this.selectedNconnectVoiceAccountSource.asObservable();

  constructor(
    private accountService: AccountService,
    private router: Router,
  ) {
    this.listenForSelectedAccountChanges();
  }

  public getNconnectApiUrl(): string {
    return this.nconnectApiUrl;
  }

  public setNconnectAccess(
    account: Account | null,
    hasNconnectAccess: boolean,
  ): void {
    this.setNconnectApiUrl(account);

    this.isNconnectVoiceAccountSelectedSource.next(hasNconnectAccess);
    this.selectedNconnectVoiceAccountSource.next(account);
  }

  private checkNconnectModuleAvailability(modules: UserModule[]): boolean {
    return !!modules?.includes(UserModule.NConnectVoice);
  }

  /**
   * Listens for selected account changes and checks if the user/account has the nconnect module
   */
  private listenForSelectedAccountChanges(): void {
    combineLatest([
      this.accountService.selectedAccount$.pipe(
        filter((account: Account | null) => !!account),
        distinctUntilChanged(),
      ),
      this.accountService.selectedAccountModules$.pipe(
        map((modules: UserModule[]) =>
          this.checkNconnectModuleAvailability(modules),
        ),
        distinctUntilChanged(),
      ),
    ]).subscribe(([account, accountHasNconnectAccess]: any) => {
      this.setNconnectAccess(account, accountHasNconnectAccess);
    });
  }

  private setNconnectApiUrl(account: Account | null): void {
    this.nconnectApiUrl = `${environment.API_URL}/nconnectvoice/${
      account!.accountType
    }:${account!.accountId}`;
  }
}
